import React from "react";
import PropTypes from "prop-types";
import { Checkbox } from "@src/components/atoms";
import { MultiSelect } from "@src/components/forms";
import AppUtils from "@src/utils/appUtils";
import { useDCContext } from "@src/context/dcContext";

const VehicleFilter = (props) => {
  const { isAviation, vehicleTypes, vehicleFilter, onChange } = props;

  const dc = useDCContext();
  const { getDynamicReplacement } = dc;

  const multiSelectOptions = [];
  const multiSelectSelectedOptions = [];
  if (!isAviation) {
    vehicleTypes.map((type) => {
      multiSelectOptions.push({
        text: type,
        value: type,
      });
    });
    vehicleFilter.map((type) => {
      multiSelectSelectedOptions.push({
        text: type,
        value: type,
      });
    });
  }

  //dynamic content
  const vehicleFilterTitle = getDynamicReplacement(
    "fuel_manager__activity__feedback_section__filters__vehicle_filter__menu_title",
  );

  const handleCheckboxChange = (vehicleType) => {
    let selectedVehicleTypes = [...vehicleFilter];
    if (
      selectedVehicleTypes.filter((type) => type === vehicleType).length > 0
    ) {
      selectedVehicleTypes = selectedVehicleTypes.filter(
        (type) => type !== vehicleType,
      );
    } else {
      selectedVehicleTypes.push(vehicleType);
    }
    onChange(selectedVehicleTypes);
  };

  const handleMultiSelectChange = (selectedOptions) => {
    const selectedVehicleTypes = [];
    selectedOptions.map((option) => {
      selectedVehicleTypes.push(option.value);
    });
    onChange(selectedVehicleTypes);
  };

  return (
    <div>
      {vehicleTypes.length > 0 && (
        <div>
          <div className="font-bold mb-1">{vehicleFilterTitle}</div>
          {isAviation ? (
            <div className="flex flex-wrap w-96">
              {vehicleTypes.map((vehicleType, index) => (
                <div
                  key={`vehicleFilter-${index}`}
                  className="flex items-center mr-3"
                >
                  <Checkbox
                    checked={
                      vehicleFilter.filter((type) => type === vehicleType)
                        .length > 0
                    }
                    name={vehicleType}
                    onChange={() => handleCheckboxChange(vehicleType)}
                  />
                  {vehicleType}
                </div>
              ))}
            </div>
          ) : (
            <MultiSelect
              options={multiSelectOptions}
              selected={multiSelectSelectedOptions}
              onChange={handleMultiSelectChange}
            />
          )}
        </div>
      )}
    </div>
  );
};

export const VehicleFilterControls = {};
VehicleFilter.propTypes = AppUtils.getPropTypeFromControls(
  VehicleFilterControls,
);

export default VehicleFilter;
